import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h93v6v8mbm: FaireBrandEntity = {
  token: "b_h93v6v8mbm",
  type: "brand",
  name: "Aurora Boheme",
  avatarUrl:
    "https://cdn.faire.com/fastly/05d9a35af046f93f6bbca7f6a3a4420abff4beb88572aba4b84ae0c90d5d2a6f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/96492ea601865ab467c02c96ebcc6b1529b028ba30b8d3ea75ace41cd7fc596f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/05d9a35af046f93f6bbca7f6a3a4420abff4beb88572aba4b84ae0c90d5d2a6f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/96492ea601865ab467c02c96ebcc6b1529b028ba30b8d3ea75ace41cd7fc596f.png",
  location: "Columbus, OH, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 9,
  isInsider: true,
  description:
    "In 2025, we lost our son after he battled for 6 months in the NICU to survive. You may notice my shop was not active for most of last year. I am eager to develop new relationships with shop owners - and have my art find new homes in your stores. Thank you for taking the time to browse my work. <3\n\nAurora Boheme was born from a desire to explore creative passions. Savannah has been creating through other mediums for years and years - but after getting her hands onto polymer clay - she fell in love. Aurora Boheme’s mission is to be the statement of expressing yourself without hesitation. With our handcrafted, unique, bohemian-inspired pieces - you can feel beautiful, self-confident and express who you are every day. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:34.130Z",
    importedBy: "entity-db-cli",
  },
};
